var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorServe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8450",
    "data-name": "Group 8450",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(1.175 0.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M1714.317,2920.67h-16.68a.583.583,0,1,0,0,1.166h16.68a.583.583,0,0,0,0-1.166Z",
    transform: "translate(-1697.054 -2911.658)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M1720.265,2879.729h-5.022a.478.478,0,1,1,0-.956h4.651a7.172,7.172,0,0,0-5.189-3.985,1.269,1.269,0,0,0-1.269-1.264h-.045a1.269,1.269,0,0,0-1.269,1.262,7.166,7.166,0,0,0-5.875,7.047h14.331A7.173,7.173,0,0,0,1720.265,2879.729Z",
    transform: "translate(-1704.491 -2873.524)",
    fill: "#5475c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0.154 11.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 3.31,
    height: 6.174,
    rx: 1,
    transform: "translate(0 0.667)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M1730.831,2932.947c-.277-1.143-1.585-.139-2.38.8a8.384,8.384,0,0,1-1.484,1.319l0,0a1.386,1.386,0,0,1-.416.282c-.1.063-.157.1-.157.1s0-.015,0-.036a5,5,0,0,1-1.636.234c-.309,0-.542-.018-.609-.024a.287.287,0,1,1,.049-.572,4.478,4.478,0,0,0,2.238-.292c0-.4-.045-.848-.255-1.014-.4-.32-2.475-.359-4.159-.449a2.776,2.776,0,0,0-2.471,1.274v3.9h5.277a5.1,5.1,0,0,0,2.428-.961C1728.091,2936.739,1731.109,2934.089,1730.831,2932.947Z",
    transform: "translate(-1715.406 -2932.437)",
    fill: "#5475c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorServe);
export default __webpack_public_path__ + "static/media/color_serve.0c2dc82b92441caf7250bc28f453b719.svg";
export { ForwardRef as ReactComponent };